
<template>
  <div class="container">
    <p>
    Thanks for visiting our <a href="https://castlabs.com/prestoplay/web-apps/" target="_blank">PRESTOplay for Web Apps</a> demo page.
    </p>

    <p>
    It seems you’re using Internet Explorer (IE). While our player does indeed support IE 11, we’ve experienced quite low demand for its support and it’s also being <a href="https://docs.microsoft.com/en-us/lifecycle/faq/internet-explorer-microsoft-edge"> phased out by Microsoft</a>. Due to this, our demo page was built without IE support.
    </p>

    <p>
    To test our player, please view this page using a modern browser such as Chrome, Firefox, Safari, or Opera.
    </p>

    <p>
    If you require testing streams on IE 11, then please <a href="https://castlabs.com/contact/" target="_blank">contact us</a> and we’d be happy to help.
    </p>
  </div>
</template>

<script>
export default {
  name: 'ie-fallback'
};
</script>

<style lang="scss" >

.container {
  width: 60%;
  margin: auto;
  padding-top: 4rem;
  font-size: 16px;
}
</style>
